// https://github.com/mrhead/todos/blob/main/app/javascript/controllers/reset_form_controller.js

import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    submit() {
        this.element.closest("form").requestSubmit();
    }
}